import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import * as actions from '../actions'

import TextField from 'material-ui/TextField'
import { Card, CardTitle, CardText } from 'material-ui/Card'
import FlatButton from 'material-ui/FlatButton'
import RaisedButton from 'material-ui/RaisedButton'
import {red500} from 'material-ui/styles/colors'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const styles = {
  card: { paddingTop: '32px' },
  button: { margin: '12px' },
  authError: { margin: '5px' }
}

// Component 
class LoginForm extends Component {
  constructor (props) {
    super(props)
    this.state = { email: props.user.email, language: 'en' }
  }

  onSelectFieldChanged (event, index, value) {
    this.setState({language: value})
  }

  onFieldChanged (event) {
    this.setState({[event.target.name]: event.target.value})
  }

  onSubmit (event) {
    event.preventDefault()
    const { email, password, language } = this.state
    this.props.onLogin(email, password, language)
  }

  render() {
    return (
      <Card style={styles.card}>
        <TextField
          floatingLabelText='Email'
          name='email'
          onChange={::this.onFieldChanged}
        /><br />
        <TextField
          floatingLabelText='Password'
          type='password'
          name='password'
          onChange={::this.onFieldChanged}
        /><br />
        <SelectField
          name='language'
          value={this.state.language}
          floatingLabelText="Select language"
          style={{textAlign: 'start'}}
          onChange={::this.onSelectFieldChanged}
        >
          <MenuItem value="en" primaryText="English" />
          <MenuItem value="cn" primaryText="Chinese" />
        </SelectField><br />
        { this.props.user.authfailed == true ? <CardText color={red500}>Login failed</CardText> : ''}
        <FlatButton label='Login' style={styles.button} onTouchTap={::this.onSubmit} />
      </Card>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLogin: (email='', password='', language='en') => {
      if (__DEV__) console.log('Submit:', email, ':', password, ':', language)
      let fetchoptions = {
          method: 'post',
          //credentials: 'omit',
          redirect: 'error',
          headers: {
              'Accept': 'application/json, text/plain, */*',
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          body: 'username=' + encodeURI(email) + '&password=' + encodeURI(password)
        }

      fetch('/app/login', fetchoptions).then((response) => {
        if(response.ok) {
          dispatch({type: 'questions/LANG', payload: language})
          dispatch(actions.login(email, password))
        } else {
          if (__DEV__) console.log('Nope');
          dispatch(actions.login('', '', true))
        }
      })
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)




// WEBPACK FOOTER //
// ./src/user/components/LoginForm.js